import { IWorkTeamState } from './interfaces';

export const initialState = {
	loading: 'idle',
	error: {},
	success: {}
} as IWorkTeamState;
